<header
	class="tw:sticky tw:top-0 tw:z-50 tw:transition-shadow tw:duration-300"
	[class.tw:shadow-md]="scrolled()"
	[class.tw:shadow-ink-900/5]="scrolled()">
	<div class="tw:bg-white/90 tw:backdrop-blur-md tw:border-b tw:border-ink-100">
		<div class="tw:mx-auto tw:max-w-7xl tw:px-4 tw:sm:px-6 tw:lg:px-8">
			<div class="tw:flex tw:h-16 tw:lg:h-20 tw:items-center tw:justify-between tw:gap-4">
				<!-- Logo -->
				<a routerLink="/" class="tw:flex tw:items-center" (click)="closeMenu()">
					<img
						[src]="brand.logoUrl"
						[alt]="brand.name"
						class="tw:h-12 tw:lg:h-14 tw:w-auto" />
				</a>

				<!-- Nav desktop -->
				<nav class="tw:hidden tw:lg:flex tw:items-center tw:gap-1">
					@for (item of nav; track item.label) {
						@if (item.children) {
							<!-- Dropdown (CSS group-hover) -->
							<div class="tw:relative tw:group">
								<a
									[routerLink]="item.path"
									routerLinkActive="tw:text-brand-700 tw:bg-brand-50"
									class="tw:flex tw:items-center tw:gap-1 tw:rounded-lg tw:px-3.5 tw:py-2 tw:text-sm tw:font-semibold tw:text-ink-700 tw:transition-colors tw:hover:text-brand-700 tw:hover:bg-brand-50">
									{{ item.label }}
									<span class="tw:text-[9px] tw:leading-none tw:transition-transform tw:group-hover:rotate-180">▾</span>
								</a>
								<!-- pt-2 = jembatan hover transparan (tanpa dead-zone) -->
								<div
									class="tw:invisible tw:absolute tw:left-0 tw:top-full tw:z-50 tw:w-56 tw:translate-y-1 tw:pt-2 tw:opacity-0 tw:transition tw:duration-150 tw:group-hover:visible tw:group-hover:translate-y-0 tw:group-hover:opacity-100">
									<div class="tw:rounded-xl tw:bg-white tw:p-1.5 tw:shadow-lg tw:ring-1 tw:ring-ink-100">
										@for (c of item.children; track c.packageType) {
											<a
												routerLink="/paket"
												[queryParams]="{ packageType: c.packageType }"
												class="tw:block tw:rounded-lg tw:px-3 tw:py-2 tw:text-sm tw:font-medium tw:text-ink-700 tw:transition-colors tw:hover:bg-brand-50 tw:hover:text-brand-700">
												{{ c.label }}
											</a>
										}
									</div>
								</div>
							</div>
						} @else {
							<a
								[routerLink]="item.path"
								routerLinkActive="tw:text-brand-700 tw:bg-brand-50"
								[routerLinkActiveOptions]="{ exact: item.path === '/' }"
								class="tw:rounded-lg tw:px-3.5 tw:py-2 tw:text-sm tw:font-semibold tw:text-ink-700 tw:transition-colors tw:hover:text-brand-700 tw:hover:bg-brand-50">
								{{ item.label }}
							</a>
						}
					}
				</nav>

				<!-- CTA + mobile toggle -->
				<div class="tw:flex tw:items-center tw:gap-2">
					<a
						[href]="waLink"
						target="_blank"
						rel="noopener"
						class="tw:hidden tw:sm:inline-flex tw:items-center tw:gap-2 tw:rounded-full tw:bg-brand-700 tw:px-4 tw:py-2.5 tw:text-sm tw:font-semibold tw:text-white tw:shadow-sm tw:transition-colors tw:hover:bg-brand-800">
						<fa-icon ngSkipHydration [icon]="['fab', 'whatsapp']" />
						Konsultasi
					</a>
					<button
						type="button"
						class="tw:lg:hidden tw:grid tw:h-10 tw:w-10 tw:place-items-center tw:rounded-lg tw:text-ink-700 tw:hover:bg-ink-100"
						(click)="toggleMenu()"
						[attr.aria-expanded]="menuOpen()"
						aria-label="Buka menu">
						@if (!menuOpen()) {
							<fa-icon ngSkipHydration icon="bars" class="tw:text-xl" />
						} @else {
							<fa-icon ngSkipHydration icon="xmark" class="tw:text-xl" />
						}
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Mobile panel -->
	@if (menuOpen()) {
		<div class="tw:lg:hidden tw:border-b tw:border-ink-100 tw:bg-white tw:shadow-lg">
			<nav class="tw:mx-auto tw:max-w-7xl tw:space-y-1 tw:px-4 tw:py-4">
				@for (item of nav; track item.label) {
					<a
						[routerLink]="item.path"
						(click)="closeMenu()"
						routerLinkActive="tw:text-brand-700 tw:bg-brand-50"
						[routerLinkActiveOptions]="{ exact: item.path === '/' }"
						class="tw:block tw:rounded-lg tw:px-4 tw:py-3 tw:text-sm tw:font-semibold tw:text-ink-700 tw:hover:bg-brand-50">
						{{ item.label }}
					</a>
					@if (item.children) {
						<div class="tw:ml-3 tw:space-y-1 tw:border-l tw:border-ink-100 tw:pl-3">
							@for (c of item.children; track c.packageType) {
								<a
									routerLink="/paket"
									[queryParams]="{ packageType: c.packageType }"
									(click)="closeMenu()"
									class="tw:block tw:rounded-lg tw:px-4 tw:py-2.5 tw:text-sm tw:text-ink-600 tw:hover:bg-brand-50 tw:hover:text-brand-700">
									{{ c.label }}
								</a>
							}
						</div>
					}
				}
				<a
					[href]="waLink"
					target="_blank"
					rel="noopener"
					class="tw:mt-2 tw:flex tw:items-center tw:justify-center tw:gap-2 tw:rounded-full tw:bg-brand-700 tw:px-4 tw:py-3 tw:text-sm tw:font-semibold tw:text-white">
					Konsultasi via WhatsApp
				</a>
			</nav>
		</div>
	}
</header>
